var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "nav-menu"
  }, [_c('div', {
    staticClass: "left-top-bar"
  }, [_c('div', {
    staticClass: "nav-link-block"
  }, [_c('user-profile')], 1), _c('div', {
    staticClass: "nav-link-block"
  }, [_c('div', {
    staticClass: "nav-link noselect",
    on: {
      "click": function click($event) {
        return _vm.showCalendar();
      }
    }
  }, [_c('img', {
    staticClass: "nav-link-icon filter-primary",
    attrs: {
      "src": "https://uploads-ssl.webflow.com/648b04f9d8e52d9524912b4a/648b04f9d8e52d9524912f0e_icons8-calendar.svg"
    }
  })])]), _c('div', {
    staticClass: "nav-link-block"
  }, [_c('div', {
    staticClass: "nav-link noselect",
    "class": [this.current === 'posudky' ? 'bl-color' : ''],
    on: {
      "click": function click($event) {
        return _vm.navigateTo('posudky');
      }
    }
  }, [_c('img', {
    staticClass: "nav-link-icon filter-primary",
    attrs: {
      "src": "https://uploads-ssl.webflow.com/648b04f9d8e52d9524912b4a/648b04f9d8e52d9524912f59_icons8-home-address.svg"
    }
  })])])]), _c('div', {
    staticClass: "right-top-bar"
  }, [_c('notification-handler', {
    attrs: {
      "rules": ['single']
    }
  })], 1), _c('audio', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "new-notification",
      "muted": "muted"
    }
  }, [_c('source', {
    attrs: {
      "src": require('@/sounds/new_message.mp3'),
      "type": "audio/mpeg"
    }
  })])]);

}
var staticRenderFns = []

export { render, staticRenderFns }